import request from 'assets/js/http';

export function financeContributeList(data) {
  // 待创建贡献表列表
  return request({
    url: '/financeContribute/list',
    method: 'post',
    data
  });
}
